import { LeadHelper } from './lead.helper';

export class TitleHelper {
  static getLeadTypeTranslation( LeadTypeId: number ): string {
    switch ( LeadTypeId ) {
      case 1:
        return 'ALT_TEXT_REQUEST_TYPE_GENERAL';
      case 3:
        return 'ALT_TEXT_REQUEST_TYPE_OFFER';
      case 4:
        return 'ALT_TEXT_REQUEST_TYPE_CUSTOMER_SERVICE';
      case 24:
        return 'ALT_TEXT_REQUEST_TYPE_CLAIM';
      case 44:
        return 'ALT_TEXT_REQUEST_TYPE_TECNICAL_QUESTION';
      case 45:
        return 'ALT_TEXT_REQUEST_TYPE_BROCHURE';
      case 46:
        return 'ALT_TEXT_REQUEST_TYPE_SAMPLE';
      case 47:
        return 'ALT_TEXT_REQUEST_TYPE_TENDER';
      case 64:
        return 'ALT_TEXT_REQUEST_TYPE_CAD_DATA';
      case 344:
      case 184:
        return 'ALT_TEXT_REQUEST_TYPE_EVENT';
      case LeadHelper.LEAD_TYPE_PLANER_RELATIONSHIP:
        return 'ALT_TEXT_PLANER_RELATIONSHIP';
      default:
        return 'ALT_TEXT_REQUEST_TYPE_GENERAL';
    }
  }
}
